import { useTranslate } from 'react-polyglot';

import { Banner } from '@genially/design-system';

interface PlayersLimitReachedNotificationProps {
  show: boolean;
  onClose?: () => void;
}

export const PlayersLimitReachedNotification = ({
  show,
  onClose,
}: PlayersLimitReachedNotificationProps) => {
  const t = useTranslate();

  return (
    <Banner
      show={show}
      onClose={onClose}
      variant={Banner.Variant.WARNING}
      text={t('__new.play.audienceLimit.creator.notification')}
    />
  );
};
